"use client"
import styled from "@emotion/styled"
import {
    DapiMetaData,
    PointsOfInterestDto
} from "api"
import { useLocale } from "next-intl"

import MapComponentBlock from "components/PazRealEstateCenter/MapComponentBlock"
import { processRichTextWithImagePrefix } from "reusable/processRichText"
import {
    CustomBreadcrumbs,
    HomeIcon,
    NewText,
    TitleWithLine,
    useIsDesktop
} from "ui"
import { extractProperty } from "utils"


const StyledContainer = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 0 146px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 0 220px;
  }
`

const StyledCont = styled.div`
  padding-bottom: 0px;
  padding-top: '0px';
  display: flex;
  flex-direction: column;
`

const StyledNewText = styled(NewText)`
    ${(props) => props.theme.breakpoints.down("sm")} {
        padding: 0 16px;
    }
`

export type PazCenterProps = {
    metadata: DapiMetaData[]
    realEstateData?: PointsOfInterestDto[] // Array of real estate points from API

    umbracoPageData: any
}

export interface UserLocation {
    lat: number;
    lon: number;
}

export function PazCenterMap({ metadata, realEstateData, umbracoPageData }: PazCenterProps) {
    const pageName = extractProperty(umbracoPageData, "pageName")
    const locale = useLocale()
    const isDesktop = useIsDesktop()
    const block = extractProperty(umbracoPageData, "blocks")?.[0]
    const title = extractProperty(block, "conetntTitle")
    const richText = extractProperty(block, "innerText")

    return (
        <StyledContainer>
            <CustomBreadcrumbs
                locale={locale}
                current={{
                    title: pageName,
                    url: `/paz-real-estate/pazcenter`,
                }}
                parents={[
                    { title: <HomeIcon />, url: "/" },
                    {
                        title: locale === "en" ? "Paz Real Estate" : "נדלן פז",
                        url: "/paz-real-estate"
                    }
                ]}
            />
            <StyledCont>
                <TitleWithLine
                    title={title}
                    titleColor="#000"
                    largeDesktopLineHeight="76.8px"
                    largeDesktopFontSize={64}
                    titleFontSize={42}
                    desktopLineHeight="50.4px"
                    noPadding
                    marginLeft={isDesktop ? 0 : 16}
                    component={"h1"}
                />
                <StyledNewText
                    largeDesktopFontSize={20}
                    largeDesktopLineHeight="28px"
                    desktopFontSize={18}
                    desktopLineHeight={"19.6px"}
                    mobileFontSize={18}
                    mobileLineHeight={"1.4"}
                    component={"p"}
                    dangerouslySetInnerHTML={{ __html: processRichTextWithImagePrefix(richText) }}
                />
                <MapComponentBlock
                    blockData={{
                        blockType: "mapComponent",
                        metadata,
                        realEstateData,
                        umbracoPageData
                    }}
                />
            </StyledCont>
        </StyledContainer>
    )
}
